'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var name = arguments[1];

    return typeof props[name] === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-a11y/lib/util/listens-to.js
// module id = 1618
// module chunks = 100 101